import { TrainingArea } from "../entity/TrainingArea";

export interface TrainingAreaValidationObj {
  name: boolean;
  code: boolean;
}

export const trainingAreaValidationObjInit = {
  name: true,
  code: true,
};

export const validateTrainingArea = (
  t: TrainingArea
): TrainingAreaValidationObj => {
  return {
    name: t.name.length > 0,
    code: t.name.length > 0,
  };
};
